import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../css/ManageProfiles.css';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';  // Assurez-vous d'importer le composant Sidebar
import API_BASE_URL from '../api';

const ManageProfiles = () => {
  const [profiles, setProfiles] = useState([]);
  const [newProfile, setNewProfile] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();



  useEffect(() => {
    const fetchProfiles = async () => {
      const token = localStorage.getItem('authToken');
      const userId = localStorage.getItem('userId'); // Ensure userId is stored in localStorage

      try {
        const response = await axios.get(`${API_BASE_URL}/api/profils`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        // Filter profiles by assignedUserId
        const filteredProfiles = response.data.filter(profile => profile.assignedUserId === userId);
        setProfiles(filteredProfiles);
      } catch (error) {
        console.error('Fetch Profiles Error:', error);
        setError('Erreur lors de la récupération des profils');
      }
    };
    fetchProfiles();
  }, []);

  const handleAddProfile = async () => {
    const token = localStorage.getItem('authToken');
    const userId = localStorage.getItem('userId'); // Ensure userId is stored in localStorage
    try {
      const response = await axios.post(`${API_BASE_URL}/api/profils`, 
        { name: newProfile, assignedUserId: userId },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      setProfiles([...profiles, response.data]);
      setNewProfile('');
    } catch (error) {
      console.error('Add Profile Error:', error);
      setError('Erreur lors de l\'ajout du profil');
    }
  };

  return (
    <div className="manage-profiles-container">
      <Sidebar />
      <div className="main-content">
        <div className="header">
          <h2>Gérer les profils</h2>
          <button className="submit-profile-button" onClick={() => navigate('/submit-profil')}>Publier un profil</button>
        </div>
        {error && <div className="alert alert-danger mt-3">{error}</div>}
        <ul className="profiles-list">
          {profiles.map((profile) => (
            <li key={profile._id} className="profile-item">
              <div className="profile-details">
                <h3>{profile.title}</h3>
                <p>{profile.jobTitle}</p>
                <div className="profile-buttons">
                  <Link to={`/profils/${profile._id}`} className="view-profile-button">Voir le profil</Link>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ManageProfiles;
